
<script>
import { required, numeric, minValue, maxValue } from "@vuelidate/validators";
import FormGroup from "@/components/molecules/form-group";
import FormInput from "@/components/molecules/form-input";
import {
  formValidationProps,
  useFormValidation
} from "@/components/organisms/mixins/form-validation.mixin";
import ButtonIcon from "@/components/molecules/button-icon";
import ButtonGroup from "@/components/molecules/button-group";

export default {
  name: "ArticleRetractationForm",
  emits: ["update:modelValue", "removeItem"],
  components: {
    FormGroup,
    FormInput,
    ButtonIcon,
    ButtonGroup
  },
  props: {
    modelValue: {
      type: Object,
      required: false,
      default: () => {}
    },
    ...formValidationProps()
  },
  setup(props) {
    const { v$, getState } = useFormValidation(props);
    return {
      v$,
      getState
    };
  },
  data() {
    return {
      article: this.modelValue
    };
  },
  beforeUpdate() {
    this.article = this.modelValue;
  },
  computed: {},
  validations() {
    return {
      article: {
        qte: {
          required,
          numeric,
          minValue: minValue(1),
          maxValue: maxValue(10)
        },
        designation: { required },
        reference: { required }
      }
    };
  },
  methods: {
    handleKeypress(event) {
      if (
        event.which !== 8 &&
        event.which !== 0 &&
        (event.which < 48 || event.which > 57)
      ) {
        event.preventDefault();
      }
    }
  }
};
</script>
<template>
  <div class="u-mb-md">
    <FormGroup
      :state="getState(v$,'qte','article')"
      class="c-inscription-form__form-group"
      size="full"
    >
      <FormInput
        v-model.trim="article.qte"
        type="number"
        :state="getState(v$,'qte','article')"
        size="full"
        @blur="article.qte.$touch()"
        @input="$emit('update:modelValue', article)"
        @keypress="handleKeypress($event)"
      >
        Quantité *
      </FormInput>
      <template #message>
        <p>
          <template v-if="v$.article.qte.required.$invalid">
            Merci de renseigner la quantité
          </template>
          <template v-else-if="v$.article.qte.minValue.$invalid">
            La quantité minimale possible est 1
          </template> <template v-if="v$.article.qte.maxValue.$invalid">
            La quantité maximale possible est 10
          </template>
        </p>
      </template>
    </FormGroup>

    <FormGroup
      :state="getState(v$,'designation','article')"
      class="c-inscription-form__form-group"
      size="full"
    >
      <FormInput
        v-model.trim="article.designation"
        type="text"
        autocomplete
        :state="getState(v$,'designation','article')"
        size="full"
        @blur="article.designation.$touch()"
        @input="$emit('update:modelValue', article)"
      >
        Désignation (exemple: t-shirt blanc taille M ) *
      </FormInput>
      <template #message>
        <p>
          <template v-if="v$.article.designation.required.$invalid">
            Merci de renseigner la désignation
          </template>
        </p>
      </template>
    </FormGroup>

    <FormGroup
      :state="getState(v$,'reference','article')"
      class="c-inscription-form__form-group"
      size="full"
    >
      <FormInput
        v-model.trim="article.reference"
        type="text"
        autocomplete
        :state="getState(v$,'reference','article')"
        size="full"
        @blur="article.reference.$touch()"
        @input="$emit('update:modelValue', article)"
      >
        Référence *
      </FormInput>
      <template #message>
        <p>
          <template v-if="v$.article.reference.required.$invalid">
            Merci de renseigner la réference
          </template>
        </p>
      </template>
    </FormGroup>
    <ButtonGroup center>
      <ButtonIcon
        variant="secondary"
        radius="full"
        icon-name="cross"
        size="md"
        icon-size="sm"
        icon-color="white"
        @click="$emit('removeItem')"
      >
        Supprimer l'article
      </ButtonIcon>
    </ButtonGroup>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/inscription-form.scss";
</style>
